import moment from "moment";

import { ChartRangeType } from "../constants";

export const getBodyForChartRequest = (
  dateRange: [Date, Date],
  chartRangeType: ChartRangeType
) => {
  const onFormatDate = (date: Date) => {
    return moment(date).format("YYYY-MM-DD");
  };

  const breakdownBy = chartRangeType === ChartRangeType.Year ? "Month" : "Day";

  return {
    from: `${onFormatDate(dateRange[0])}T00:00:00.000Z`,
    to: `${onFormatDate(dateRange[1])}T23:59:59.999Z`,
    breakdownBy
  };
};
